import * as React from 'react';
import { BSDescriptionSection as TBSDescriptionSection } from '~/common/types/types';
import { FormattedMessage } from '~/components/common/common';
import * as styles from './bs-description-section.module.scss';

type Props = {
  section: TBSDescriptionSection;
};

const BSDescriptionSection: React.FC<Props> = ({ section }) => {
  const { title, items } = section;

  return (
    <section>
      <h3 className={styles.sectionTitle}>
        <FormattedMessage message={title} />
      </h3>
      {items.map((it) => (
        <p key={it} className={styles.sectionParagraph}>
          <FormattedMessage message={it} />
        </p>
      ))}
    </section>
  );
};

export { BSDescriptionSection };
